import React from 'react';
import Slider from 'react-slick';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import cx from 'classnames';
import OnVisible, { setDefaultProps } from 'react-on-visible';
import { Link as ScrollLink, Element, Events } from 'react-scroll';
import Link from '../../components/Link';
import style from './Home.css';
import { EXPIRED_USER } from '../../constants';
import icon1 from '../../../public/icons/home-001.jpg';
import icon2 from '../../../public/icons/home-002.jpg';
import icon3 from '../../../public/icons/home-003.jpg';
import icon4 from '../../../public/icons/home-004.jpg';
import carousel1 from '../../../public/icons/Asset 3.1.png';
import carousel2 from '../../../public/icons/Asset 3.2.png';
import carousel3 from '../../../public/icons/Asset 3.3.png';
import computerIcon from '../../../public/icons/learn-with-us.png';
import paperPlane from '../../../public/icons/paper-plane.png';
import scrollUpIcon from '../../../public/icons/scroll-up.png';
import scrollDownIcon from '../../../public/icons/scroll-down.png';

setDefaultProps({
  bounce: true,
  visibleClassName: 'seen'
});

const mapStateToProps = state => ({
  userRole: state.auth.user.role_id
});

class Home extends React.Component {
  static settings = {
    autoplay: true,
    fade: true,
    infinite: true,
    autoplaySpeed: 3000,
    speed: 100,
    arrows: true,
    dots: true,
    className: 'slides'
  };

  constructor(props) {
    super(props);
    this.state = {
      seenSections: [1]
    };
    this.toggleScroll = this.toggleScroll.bind(this);
  }

  componentDidMount() {
    Events.scrollEvent.register('begin');
    Events.scrollEvent.register('end');
    const { userRole } = this.props;
    if (userRole === EXPIRED_USER && typeof window !== 'undefined') {
      if (typeof window.toastr !== 'undefined') {
        this.showExpiredTrialNotification();
      } else {
        // If toastr was undefined, wait for one second and then attempt to show
        // the notification.
        setTimeout(this.showExpiredTrialNotification, 1000);
      }
    }
  }

  componentWillUnmount() {
    Events.scrollEvent.remove('begin');
    Events.scrollEvent.remove('end');
  }

  showExpiredTrialNotification() {
    if (typeof window.toastr !== 'undefined') {
      const message =
        '<span style={{ fontSize: "18px",  lineHeight: 1, marginBottom: "10px", display: "block" }}>Your trial membership has expired!</span>';
      const button =
        '<a className="btn btn-default" href="/tbd" role="button" style={{ color: "#000" }}>Click Here To Buy A Package</a>';
      // Set custom options for the message
      window.toastr.options.closeButton = true;
      window.toastr.options.timeOut = 0;
      window.toastr.options.extendedTimeOut = 0;
      // Show error notification
      window.toastr.error(`${message}${button}`);
      // Reset options after showing the error
      window.toastr.options.closeButton = false;
      window.toastr.options.timeOut = 3000;
      window.toastr.options.extendedTimeOut = 2000;
    }
  }

  scrollUp(seenSections) {
    if (seenSections.length < 2) return null;
    const link = seenSections.length === 2 ? 'sectionOne' : 'sectionTwo';
    return (
      <div className={cx('hidden-xs', style.scroll, style.scrollUp)}>
        <ScrollLink to={link} smooth={true} duration={500}>
          <img
            src={scrollUpIcon}
            className={style.scrollIcon}
            alt="Parkland Players"
          />
        </ScrollLink>
      </div>
    );
  }

  scrollDown(seenSections) {
    if (seenSections.length === 0 || seenSections.indexOf(3) !== -1)
      return null;
    const link = seenSections.length === 1 ? 'sectionTwo' : 'sectionThree';
    return (
      <div className={cx('hidden-xs', style.scroll, style.scrollDown)}>
        <ScrollLink to={link} smooth={true} duration={500}>
          <img
            src={scrollDownIcon}
            className={style.scrollIcon}
            alt="Parkland Players"
          />
        </ScrollLink>
      </div>
    );
  }

  toggleScroll(section, isVisible) {
    const index = this.state.seenSections.indexOf(section);
    const isRecorded = index !== -1;
    /* do nothing if the section
        - is already recorded and is visible: isRecorded && isVisible
        - is not recorded and not visible: !isRecorded && !isVisible */
    if (isRecorded && !isVisible) {
      // isn't visible anymore, remove from seen sections
      this.setState({ seenSections: section === 3 ? [1, 2] : [1] });
    } else if (!isRecorded && isVisible) {
      // is newly visible, add to seen sections
      this.setState({ seenSections: [...this.state.seenSections, section] });
    }
    /* following scenario should not happen, but just in case */
    if (this.state.seenSections.length === 0) {
      this.setState({ seenSections: [1] });
    }
  }

  render() {
    const carousel = [
      {
        icon: carousel1,
        title: 'CONSTRUCTING LIFE LONG LEARNERS',
        description:
          'This app is meant to support childcare providers and parents in a variety of settings with thinking of and ' +
          'creating age appropriate programming for children'
      },
      {
        icon: carousel2,
        title: 'BUILDING OPPORTUNITIES FOR EDUCATION',
        description:
          'The goal of this resource is to provide a starting point, and inspirations to build on'
      },
      {
        icon: carousel3,
        title: 'CONSTRUCTING LIFE LONG LEARNERS',
        description:
          'This app is meant to support childcare providers and parents in a variety of settings with thinking of and ' +
          'creating age appropriate programming for children'
      }
    ];
    const carouselPanel = (
      <Slider {...Home.settings}>
        {carousel.map((item, index) =>
          <div className={cx('item')} key={'carousel-' + index}>
            <img
              src={item.icon}
              alt="carousel"
              style={{ width: '100%' }}
              className="img-responsive"
            />
            <div className={cx('carousel-caption', style.customCaption)}>
              <h2>
                {item.title}
              </h2>
              <p>
                {item.description}
              </p>
            </div>
          </div>
        )}
      </Slider>
    );

    const actions = [
      {
        icon: icon1,
        title: 'Empowering',
        description:
          'Empowering parents to gain a better understanding of how their children learn. Empowering ' +
          'educators to provide child-focused programming. Empowering children to direct their own learning experiences.'
      },
      {
        icon: icon2,
        title: 'Education',
        description:
          'We are adding to the education conversation with a collection of diverse activities that allow educators to ' +
          'develop their personal approaches and allow children to further understand who they are as active learners.'
      },
      {
        icon: icon3,
        title: 'Building Blocks',
        description:
          'The activities contained in this resource focus on the core developmental domains of art, music, ' +
          'physical/motor skills, literacy, mathematics, science, and social/emotional skills.'
      },
      {
        icon: icon4,
        title: 'Achievement',
        description:
          'By using this app you can expect to see increased engagement from parents, educators, and children as they ' +
          'collaborate in the learning process.'
      }
    ];
    const actionsPanel = (
      <section id="actions" className={style.section}>
        <div className={'row'}>
          <div className={cx('col-md-12', 'text-center', style.learnTitle)}>
            TAKE ACTION
          </div>
        </div>
        <div className={'row text-center'}>
          {actions.map((action, index) =>
            <div
              className={cx('col-md-3', style.action)}
              key={'action-' + index}
            >
              <img src={action.icon} height="100px" alt="Parkland Players" />
              <h3>
                {action.title}
              </h3>
              <div className={style.actionItem}>
                {action.description}
              </div>
            </div>
          )}
        </div>
      </section>
    );

    const learningItems = [
      {
        icon: computerIcon,
        description:
          'This resource is meant to provide a framework of education-based activities for all age groups. ' +
          'The ideas contained in this book are intended to give inspiration and a starting point for activities.'
      },
      {
        icon: computerIcon,
        description:
          'They are open to interpretation and children should be given choice within all activities to ' +
          'explore the task and concepts however they see fit. Be sure to leave activities as open-ended as possible, ' +
          'provide the resources so children can direct their own learning.'
      },
      {
        icon: computerIcon,
        description:
          'Content ordered based on the school year and annual events.'
      }
    ];

    const learnPanel = (
      <section id="learn" className={style.section}>
        <div className={'row'}>
          <div className={cx('text-center', style.learnTitle)}>
            LEARN WITH US
          </div>
          <Slider {...Home.settings}>
            {learningItems.map((item, index) =>
              <div className={cx('item', 'row')} key={`item-${index}`}>
                <div className="col-md-4 col-md-offset-2 col-sm-12">
                  <img
                    src={item.icon}
                    className={cx(
                      'img-responsive',
                      'center-block',
                      style.learnIcon
                    )}
                  />
                </div>
                <div
                  className={cx(
                    'col-md-3 col-sm-12',
                    'text-center',
                    style.learnText
                  )}
                >
                  <div>
                    {item.description}
                  </div>
                </div>
                <div className="col-md-3" />
              </div>
            )}
          </Slider>
          <div className="col-md-6 col-md-offset-3 text-center">
            <Link to="/contact" className={style.linkToContact}>
              <div className={style.connectText}>
                WE WOULD LOVE TO HEAR FROM YOU
              </div>
              <img src={paperPlane} className={style.paperPlane} />
            </Link>
          </div>
        </div>
      </section>
    );

    return (
      <div className={'container-fluid'}>
        {this.scrollUp(this.state.seenSections)}
        {this.scrollDown(this.state.seenSections)}
        <Element id="containerElement">
          <Element name="sectionOne">
            {carouselPanel}
          </Element>
          <hr className={style.divider} />
          <OnVisible
            id="learn"
            onChange={isVisible => {
              this.toggleScroll(2, isVisible);
            }}
          >
            <Element name="sectionTwo">
              {actionsPanel}
            </Element>
          </OnVisible>
          <hr className={style.divider} />
          <OnVisible
            id="actions"
            onChange={isVisible => {
              this.toggleScroll(3, isVisible);
            }}
          >
            <Element name="sectionThree">
              {learnPanel}
            </Element>
          </OnVisible>
        </Element>
      </div>
    );
  }
}

export default connect(mapStateToProps, null)(withStyles(style)(Home));



// WEBPACK FOOTER //
// ./src/routes/home/Home.js